import VueProgressBar from 'vue-progressbar';
import VueProgressiveImage from 'vue-progressive-image';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.use(VueProgressBar, {
  color: '#fff',
  failedColor: 'red',
  thickness: '5px',
});

Vue.use(VueProgressiveImage, {
  blur: 0,
});

new Vue({
  VueProgressBar,
  router,
  render: h => h(App),
}).$mount('#app');
